module.exports = __webpack_public_path__ + "static/media/folder-open-purple.739e7136.svg";